module.exports = {

	events: {
		showVariables: {
			type: 'click',
			selector: 'button',
			action: function(event){
				event.preventDefault();
				event.stopImmediatePropagation();

				var self = event.data.component;
				var $target = $(event.target);

				$target.hide();
				self.$.find('.variables').show();

			}
		},
		hideVariables: {
			type: 'click',
			selector: '.variables span',
			action: function(event){
				event.preventDefault();
				event.stopImmediatePropagation();

				var self = event.data.component;
				self.$.find('.variables').hide();
				self.$.find('button').show();
			}
		}

	}
};